import { render, staticRenderFns } from "./mukeCooperation.vue?vue&type=template&id=05fd7241&scoped=true"
import script from "./mukeCooperation.vue?vue&type=script&lang=js"
export * from "./mukeCooperation.vue?vue&type=script&lang=js"
import style0 from "./mukeCooperation.vue?vue&type=style&index=0&id=05fd7241&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fd7241",
  null
  
)

export default component.exports